import { configure } from "../../config/app";

export const isAuthorized = () =>  localStorage.getItem(configure.StorageKey.Vendor) !== null;
export const hasSelectedStore = () =>  localStorage.getItem(configure.StorageKey.CurrentStore) !== null;
export const getCurrentVendor = () => JSON.parse(localStorage.getItem(configure.StorageKey.Vendor));
export const getCurrentStore = () => JSON.parse(localStorage.getItem(configure.StorageKey.CurrentStore));
export const getCurrentStoreBranch = () => JSON.parse(localStorage.getItem(configure.StorageKey.CurrentStoreBranch));
export const getWaiter = () => JSON.parse(sessionStorage.getItem(configure.StorageKey.Waiter));
export const isWaiterAuthorized = () => sessionStorage.getItem(configure.StorageKey.Waiter) !== null;
export const isStoreOpen = () => localStorage.getItem(configure.StorageKey.IsStoreOpen) === "1";